<template>
    <div class="container-fluid">
        <div><h3>Atividades</h3></div>
        <form v-on:submit.prevent="create" class="row">
            <div class="form-group col-md-4">
                <input class="form-control" id="name" v-model="name" ref="name" placeholder="Nome"/>
                <span class="text-danger">{{ errors.hasOwnProperty('name') ? errors.name[0] : '' }}</span>
            </div>
            <div class="col-md-4">
                <button type="submit" class="btn btn-success">Salvar</button>
            </div>
        </form>
        <ul class="crud-pills nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
                <button class="nav-link active" id="active-tab" data-bs-toggle="pill" data-bs-target="#active" type="button" role="tab" aria-controls="active" aria-selected="true">Ativas</button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link" id="disabled-tab" data-bs-toggle="pill" data-bs-target="#disabled" type="button" role="tab" aria-controls="disabled" aria-selected="false">Desativadas</button>
            </li>
        </ul>
        <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade show active" id="active" role="tabpanel" aria-labelledby="active-tab">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th>Nome</th>
                        <th width="120px">Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="task in tasks" :key="task.id">
                        <td><input class="form-control hide-input" v-model="task.name" v-on:blur="edit(task)"></td>
                        <td>
                            <button class="btn btn-danger" v-on:click="destroy(task.id)"><i class="far fa-trash-alt"></i></button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="tab-pane fade" id="disabled" role="tabpanel" aria-labelledby="disabled-tab">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th>Nome</th>
                        <th width="120px">Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="task in deletedTasks" :key="task.id">
                        <td><input class="form-control hide-input" v-model="task.name" v-on:blur="edit(task)"></td>
                        <td>
                            <button class="btn btn-success" v-on:click="activate(task.id)"><i class="fas fa-check"></i></button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'Tasks',
        data () {
            return {
                tasks: {},
                name: '',
                errors: {},
                deletedTasks: {},
            }
        },
        mounted (){
            this.deleted()
            this.index()
        },
        methods: {
            create () {
                axios.post('/api/tasks', { name: this.name })
                    .then(() => {
                        this.name = ''
                        this.$refs.name.focus()
                        this.index()
                        this.errors = {}
                    })
                    .catch((error) => {
                        this.errors = error.response.data.errors;
                    })
            },
            index () {
                axios
                    .get('/api/tasks')
                    .then((response) => {
                        this.tasks = response.data
                    })
            },
            destroy (id) {
                this.$confirm(
                    {
                        message: `Tem certeza que deseja excluir?`,
                        button: {
                            no: 'Não',
                            yes: 'Sim'
                        },
                        callback: confirm => {
                            if (confirm) {
                                axios.delete('/api/tasks/' + id)
                                    .then(() => {
                                        this.index()
                                        this.deleted()
                                    })
                            }
                        }
                    }
                )
            },
            edit (task) {
                axios.put('/api/tasks/' + task.id, { name: task.name })
                    .catch(() => {
                        this.$confirm(
                            {
                                title: 'Erro',
                                message: `Já existe uma atividade com este nome.`,
                                button: {
                                    yes: 'OK',
                                },
                                callback: confirm => {
                                    if (confirm) {
                                        this.index()
                                        this.deleted()
                                    }
                                }
                            }
                        )
                    })
            },
            deleted () {
                axios
                    .get('/api/tasks/deleted')
                    .then((response) => {
                        this.deletedTasks = response.data
                    })
            },
            activate (id) {
                this.$confirm(
                    {
                        message: `Tem certeza que deseja reativar?`,
                        button: {
                            no: 'Não',
                            yes: 'Sim'
                        },
                        callback: confirm => {
                            if (confirm) {
                                axios.put('/api/tasks/activate/' + id)
                                    .then(() => {
                                        this.index()
                                        this.deleted()
                                    })
                            }
                        }
                    }
                )
            }
        }
    }
</script>
